<template>
    <section
        class="cta section center-content"
        :class="[
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div class="container">
            <div
                class="cta-inner section-inner reveal-scale-down"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider',
                    split && 'cta-split'
                ]">
                <div class="cta-slogan">
                    <div class="container-xs">
                        <h2 class="mt-0 mb-8">
                            Nisi porta lorem mollis aliquam ut.
                        </h2>
                        <p class="m-0">
                            A pseudo-Latin text used in web design, layout, and printing in place of things to emphasise layouts.
                        </p>
                    </div>
                </div>
                <div class="cta-action">
                    <c-button tag="a" color="secondary" wide-mobile href="#">
                        Get started
                    </c-button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionProps } from '@/utils/SectionProps.js'
import CButton from '@/components/elements/Button.vue'

export default {
  name: 'CCta',
  components: {
    CButton
  },
  mixins: [SectionProps],
  props: {
    split: {
      type: Boolean,
      default: false
    }
  }
}
</script>